import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const TONES = {
  info: { bg: "#EEF5FF", border: "#B9D5FF", icon: "#2463A8", text: "#173B65" },
  success: { bg: "#ECF9F1", border: "#A9DEC0", icon: "#1E7A46", text: "#175A36" },
  warning: { bg: "#FFF6E8", border: "#F4CF91", icon: "#A86200", text: "#744600" },
  danger: { bg: "#FFF0F0", border: "#F2B8B8", icon: "#B32D2D", text: "#7C2020" },
};

export default function MovementCoachBubble({ title, children, tone = "info", compact = false }) {
  const palette = TONES[tone] || TONES.info;

  return (
    <Box
      sx={{
        position: "relative",
        px: compact ? 1.5 : 1.8,
        py: compact ? 1.2 : 1.5,
        bgcolor: palette.bg,
        border: `1px solid ${palette.border}`,
        borderRadius: 2.5,
        color: palette.text,
        "&::after": {
          content: '""',
          position: "absolute",
          left: 22,
          bottom: -7,
          width: 13,
          height: 13,
          bgcolor: palette.bg,
          borderRight: `1px solid ${palette.border}`,
          borderBottom: `1px solid ${palette.border}`,
          transform: "rotate(45deg)",
        },
      }}
    >
      <Stack direction="row" spacing={1.1} alignItems="flex-start">
        <InfoOutlinedIcon sx={{ mt: 0.15, fontSize: compact ? 19 : 21, color: palette.icon }} />
        <Box>
          {title ? <Typography sx={{ fontWeight: 900, lineHeight: 1.25 }}>{title}</Typography> : null}
          <Typography variant="body2" sx={{ mt: title ? 0.35 : 0, lineHeight: 1.5, color: "inherit" }}>
            {children}
          </Typography>
        </Box>
      </Stack>
    </Box>
  );
}
